(function () {
    function initProgressBar(sectionId) {
        const productGrid = document.querySelector(`#Slider-${sectionId}`);
        const progressIndicator = document.querySelector(`.featured-collection__scroll-progress-indicator[data-section-id="${sectionId}"]`);

        if (!productGrid || !progressIndicator) return;

        function updateProgress() {
            const scrollLeft = productGrid.scrollLeft;
            const scrollWidth = productGrid.scrollWidth;
            const clientWidth = productGrid.clientWidth;
            const maxScroll = scrollWidth - clientWidth;

            if (maxScroll <= 0) {
                progressIndicator.style.width = '100%';
                return;
            }

            if (scrollLeft + clientWidth >= scrollWidth - 1) {
                progressIndicator.style.width = '100%';
                return;
            }

            if (scrollLeft === 0) {
                progressIndicator.style.width = '8%';
                return;
            }

            const progress = (scrollLeft / maxScroll) * 100;
            progressIndicator.style.width = progress + '%';
        }

        productGrid.addEventListener('scroll', updateProgress);
        window.addEventListener('resize', updateProgress);
        updateProgress();
    }

    // Initialize for all featured collection sections on the page
    document.addEventListener('DOMContentLoaded', function () {
        const progressIndicators = document.querySelectorAll('.featured-collection__scroll-progress-indicator');
        progressIndicators.forEach(function (indicator) {
            const sectionId = indicator.getAttribute('data-section-id');
            if (sectionId) {
                initProgressBar(sectionId);
            }
        });
    });
})();
